import { useRoutes } from "./routes"
import { ToastContainer } from "react-toastify"
import { useAuth } from "hooks/api/auth/auth.hook"
import "./assets/scss/style.scss"

export const App = () => {
	const { isAuthenticated } = useAuth()
	const routes = useRoutes(isAuthenticated)

	return (
		<>
			{routes}
			<ToastContainer />
		</>
	)
}
